import React, { useState } from 'react';
import { Grid, Box, Link } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

const SummaryField = ({ courseData, setCourseData, showIcons, setShowIcons }: any) => {
    const [summary, setSummary] = useState(courseData.summary || '');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newSummary = e.target.value;
        setSummary(newSummary);
        // Update contentData with the new title
        setCourseData((prevContentData: any) => ({
            ...prevContentData,
            summary: newSummary,
        }));
        // Update showIcons visibility immediately for `contentTitle`
        setShowIcons((prevState: any) => ({
            ...prevState,
            summary: newSummary.length > 0,  // Update contentTitle instead of title
        }));
    };


    return (
        <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
            <Grid item xs={12} sm={6} gap={1} display={"flex"} flexDirection={"column"}>
                <label
                    htmlFor="summary"
                    style={styleSheet.labelText}
                >
                    Summary for this handout
                </label>
                <Grid display={"flex"} gap={2} alignItems={"center"} flex={1}>
                    <Box sx={{ flexGrow: 1 }}>
                        <CustomTextField
                            name="summary"
                            multiline
                            rows={6}
                            sx={{ width: '100%', maxWidth: '654px' }}
                            value={summary}
                            onChange={handleChange}
                        />
                    </Box>
                </Grid>
            </Grid>

        </Grid>
    );
};

export default SummaryField;
const styleSheet = {
    labelText: {
        fontWeight: 400, fontSize: "17px", color: "#000000",
    }
}